import React, { useEffect } from 'react';
import '../AboutStyles/AboutMain.css';

const AboutMain = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('[data-animate]').forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="about-hero">
      <div className="about-hero-inner">
        <div className="about-hero-content" data-animate="slideInLeft">
          <span className="about-badge">About Us</span>
          <h1 className="about-hero-title">
            Driving Digital Innovation
            <span className="about-hero-highlight"> Across Every Industry</span>
          </h1>
          <p className="about-hero-subtitle">
            We are Bellary Info Tech Solutions — a passionate team of engineers, designers, and
            problem-solvers committed to building technology that transforms businesses worldwide.
          </p>
          <div className="about-hero-stats">
            <div className="about-stat">
              <span className="about-stat-number">10+</span>
              <span className="about-stat-label">Projects Delivered</span>
            </div>
            <div className="about-stat-divider"></div>
            <div className="about-stat">
              <span className="about-stat-number">10+</span>
              <span className="about-stat-label">Happy Clients</span>
            </div>
          </div>
        </div>

        <div className="about-hero-visual" data-animate="slideInRight">
          <div className="about-orbit-wrapper">
            <div className="about-center-circle">
              <span className="about-center-logo">BITS</span>
            </div>
            <div className="about-floating-card card-top">
              <i className="bi bi-code-slash"></i>
              <span>Web Dev</span>
            </div>
            <div className="about-floating-card card-right">
              <i className="bi bi-phone"></i>
              <span>Mobile</span>
            </div>
            <div className="about-floating-card card-bottom">
              <i className="bi bi-receipt-cutoff"></i>
              <span>Billing</span>
            </div>
            <div className="about-floating-card card-left">
              <i className="bi bi-headset"></i>
              <span>Support</span>
            </div>
            <div className="orbit-ring ring-1"></div>
            <div className="orbit-ring ring-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMain;
